var map = {
	"./graphics/FG.gif": 83222,
	"./graphics/FG.png": 26217,
	"./graphics/Fabrik.gif": 9992,
	"./graphics/Farblabor.gif": 11318,
	"./graphics/Gustav.gif": 38771,
	"./graphics/grolm.gif": 14290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32809;